import React from "react";
import { useSelector } from "react-redux";
import { IconButton } from "../../base/buttons";
import { getRecordingParticipantsCount } from "../../base/participants";
import { RECORD_MODAL_ID } from "../../options";

export default function RecordingButton() {
    const recording = useSelector(state =>  getRecordingParticipantsCount(state) > 0 ? true : false);
    const onClick = () => {
        APP.UI.openModal(RECORD_MODAL_ID);
    }

    return (
        <>
            { recording && <IconButton clsName="rec" mode="recording" onClick={onClick} /> }
        </>
    );
}